<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tPqDTQ/tc-custom/9781626810372.jpg?1696640485568" alt="This image is the cover for the book Winter Roses, The Fire Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winter Roses, The Fire Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A shocking scandal. An undeniable passion. A medieval Scottish romance from “an amazingly talented author who has few rivals” (<i>RT Book Reviews</i>).</b><br/>  <br/> Arabella of Byrum’s stunning beauty is a blessing and a curse. It drew the brutal Elias of Woolford to make an irresistible offer for her hand in marriage, and it fueled the jealous rage that made Elias break that bond—leaving Arabella with an infant Elias refuses to acknowledge as his, and a shattered reputation.<br/>  <br/> Despite the slanderous rumors about Arabella, William of Dunashie wants her when no other lord will. In his arms, Arabella discovers what the true power of love is, and can only hope that power will keep her safe as she searches a shadowy labyrinth of evil intrigue for the way to clear her name.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anita Mills
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28a359ba